import React, { Component, Fragment } from 'react';
import Switch from '@material-ui/core/Switch';
import CircularProgress from '@material-ui/core/CircularProgress'

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

import { Navigationmenu } from '../components';
import  UpdateRecords  from '../components/UpdateRecords';
import {
    Box,
    Button,
    Typography,
    Grid,
    Divider,
    MuiEditableLabel,
    TextField,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    FormControl,
    Select,
    InputLabel,
    MenuItem,
    Popover,
    Dialog,
    Checkbox,
    Tabs,
    Tab,
    DialogActions,
    withStyles,
    TableFooter
} from '@material-ui/core';
import {
    SearchOutlined,
    ArrowDropDown,
    Publish,
    NoteAdd,
    ArrowDropUp,
    InsertDriveFileOutlined,
    AlternateEmail,
    RepeatOneSharp
} from '@material-ui/icons';
import {
    ALTERNATEROW_BACKGROUND_COLOR,
    BLUE_COLOR, LIGHTGRAY_COLOR,
    MODIFIEDBLACK,
    PINK_COLOR,
    PROTECT_GREEN,
    RED_COLOR,
    VIBRANT_GREEN
} from "../constants";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import List from "@material-ui/core/List";
import renderIf from 'render-if';
import { Redirect } from "react-router-dom";
import CloseIcon from '@material-ui/icons/Close';
import Toolbar from "@material-ui/core/Toolbar";
import axios from "axios"
import { fnPostapiResponse, fnGETapiResponse } from '../APICall';

const StyledTabs = withStyles({
    indicator: {
        display: 'flex',
        backgroundColor: 'white',
        height: 3
    },
}, { index: 1 })((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        color: 'white',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        '&:focus': {
            opacity: 1
        }
    },
}, { index: 1 }))((props) => <Tab disableRipple {...props} />);

export default class MTNSSTMVLS extends Component {
    constructor() {
        super();
        this.state = {
            input: {},
            errors: {},
            tablebuffer: [],
            pages: 0,
            current: 1,
            records: 0,
            pageSize: 10,
            showPager: false,
            SOURCE: "",
            FNAME: "",
            SNAME: "",
            pagesObj: [],
            DDNIC: "",
            disableNic: false,
            DDFIRSTNAME: "",
            DDLASTNAME: "",
            DDUSERNAME: "",
            DDFRELATIONSHIP: "",
            DDMOBILENO: "",
            DDEMAILADDRESS: "",
            DDTOTALCARDNO: "",
            CMLFORENAME: "",
            CMLEMAIL: "",
            DDSELECTEDATE: "",
            disabled: false,
            DisabledButton: true,
            DELETEBUTTONCHANGE: LIGHTGRAY_COLOR,
            CMLMOBILE: "",
            CMLTELHOME: "",
            CMLOFFICE: "",
            CMLCLIENT: "",
            CMLISLODING: false, CMLDDLCHANNEL: "", CMLDDLMODE: "",
            DRIVEREXPDATE: "",
            GroupingCodeArry: [],
            SelectedGroupingCode: '',
            txtDesciption: '',
            txt_GROUP_CHARVAL_2: '',
            txt_GROUP_CHARVAL_1: '',
            txt_GROUP_CHARVAL_3: '',
            txtGrpcontestcode: "",
            txtOrdering: "",
            txtnumVal: "",
            txtlblReceive: "",
            displayaddtext: 'none',
            disableDescription: true,
            updatebuttonText: 'Update',
            showDialog:false
        };

        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        var date = new Date()
        var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
        var date1 = date.getDate() < 10 ? "0" + (date.getDate()) : date.getDate()
        this.state.DDSELECTEDATE = date.getFullYear() + "" + month + date1
        this.fnfillgrpvaluesdropdown()
    }
    handleSearchClick(e) {
        this.Searchdatavalue()
    }

    handleChange(event) {
        let input = this.state.input;
        input[event.target.name] = event.target.value;

        this.setState({
            input
        });
        if (event.target.name == "DDEMAILADDRESS")
            this.validate();
    }


    validate() {
        let input = this.state.input;
        let errors = {};
        let isValid = true;
        if (!input["DDEMAILADDRESS"]) {
            isValid = false;
            errors["DDEMAILADDRESS"] = "Please enter your email Address.";
        }
        if (typeof input["DDEMAILADDRESS"] !== "undefined") {
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(input["DDEMAILADDRESS"])) {
                isValid = false;
                errors["DDEMAILADDRESS"] = "Please enter valid email address.";
            }
        }


        this.setState({
            errors: errors
        });

        return isValid;
    }
    handleUpdateClick(e) {
        console.log("Update button text check", e)
        if (e == 'Update') {
            var r = window.confirm("Do you want to Update details ?")
            if (r) {
               // this.updateRowdata()
            }
        }
        else {
            this.addRowdata()
        }

    }
    addRowdata() {
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'InsertGRPDETPF',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": {
                "GROUP_VALUES": this.state.SelectedGroupingCode,
                "DESC50": this.state.txtDesciption,
                "ORDERING": this.state.txtOrdering,
                "NUMVAL": this.state.txtnumVal,
                "USER_INITIAL": "CDN",
                "GROUP_CONTEST_CODE": this.state.txtGrpcontestcode,
                "LABELRECEIVE": this.state.txtlblReceive,
                "GROUP_CHARVAL_1": this.state.txt_GROUP_CHARVAL_1,
                "GROUP_CHARVAL_2": this.state.txt_GROUP_CHARVAL_2,
                "GROUP_CHARVAL_3": this.state.txt_GROUP_CHARVAL_3
            }
        }

        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            alert(response.data)
            this.clearDDdetails()
        }).catch(e => console.log(e));
    }
    updateRowdata() { 
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'UpdateGRPDETPF',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": {
                "GROUP_VALUES": this.state.SelectedGroupingCode,
                "DESC50": this.state.txtDesciption,
                "ORDERING": this.state.txtOrdering,
                "GROUP_CONTEST_CODE": this.state.txtGrpcontestcode,
                "GROUP_CHARVAL_1": this.state.txt_GROUP_CHARVAL_1,
                "GROUP_CHARVAL_2": this.state.txt_GROUP_CHARVAL_2,
                "GROUP_CHARVAL_3": this.state.txt_GROUP_CHARVAL_3
            }
        }

        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            alert(response.data)
            this.clearDDdetails()
        }).catch(e => console.log(e));
    }
    deletedriverinSql(swnactid, expdate, cmtactid, dtupdate, usrupdate) {

    }
    handlesaveClick() {
        this.checkallentry()
    }
    checkallentry() {
        if (this.state.DDNIC.trim() == "" || this.state.DDFIRSTNAME.trim() == "" || this.state.DDLASTNAME.trim() == "" || this.state.DDUSERNAME.trim() == "" || this.state.DDFRELATIONSHIP.trim() == "" ||
            this.state.DDMOBILENO.trim() == "" || this.state.input.DDEMAILADDRESS == "" || this.state.input.DDEMAILADDRESS == undefined || this.state.DDTOTALCARDNO.trim() == "") {
            alert("Record cannot be saved! Please fill all mandatory fields Denoted by *")

        }
        else if (this.state.errors["DDEMAILADDRESS"] != undefined) {
            alert("Please enter valid email address.")
            return
        }
        else {
            if (this.state.disableNic) {
                if (this.state.DRIVEREXPDATE != "") {

                    var r = window.confirm("Driver deactivated. Do you wish to reactivate driver?")
                    if (r) {
                        var accid = this.state.DDNIC
                        var Exdate = null
                        this.updateUserandActivate(accid, Exdate)
                        this.clearDDdetails()
                    }
                }

                else {
                    let requestOptions = {
                        method: 'POST',
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json',
                            'X-Cmt-Api-Key': '' + process.env.REACT_APP_HEADER_KEY + ''
                        },
                        body: JSON.stringify({
                            "users": [
                                {
                                    "account_id": this.state.DDNIC.toUpperCase(),
                                    "email": this.state.input.DDEMAILADDRESS,
                                    "username": this.state.DDUSERNAME.toUpperCase(),
                                    "first_name": this.state.DDFIRSTNAME.toUpperCase(),
                                    "last_name": this.state.DDLASTNAME.toUpperCase(),
                                    //  "mobile":this.state.DDMOBILENO.toUpperCase(),
                                    //  "mobile_sms":this.state.DDMOBILENO.toUpperCase(),
                                    "expiration_date": null
                                }
                            ]
                        })
                    }

                    console.log("Update CMT body", requestOptions.body)
                    fetch('' + process.env.REACT_APP_CLIENTMOBILE_URL + '', requestOptions)
                        .then(async response => {
                            const data = await response.json();
                            console.log(data)
                            if (data.error_description != undefined) {
                                alert(data.error_description)
                                return
                            }
                            // check for error response
                            if (!response.ok) {
                                // get error message from body or default to response status
                                const error = (data && data.message) || response.status;
                                return Promise.reject(error);
                            }

                            var swnactid = this.state.DDNIC.toUpperCase()
                            var cmtactid = data['users'][0]['short_user_id']
                            var mobileno = this.state.DDMOBILENO.toUpperCase()
                            var email = this.state.input.DDEMAILADDRESS
                            var relationship = this.state.DDFRELATIONSHIP.toUpperCase()
                            var username = this.state.DDUSERNAME.toUpperCase()
                            var lastname = this.state.DDLASTNAME.toUpperCase()
                            var firstname = this.state.DDFIRSTNAME.toUpperCase()
                            var totalcardno = this.state.DDTOTALCARDNO.toUpperCase()
                            var expdate = ""

                            var dtupdate = this.state.DDSELECTEDATE
                            var usrupdate = sessionStorage.getItem("username")

                            this.UpdateUserafterSearch(swnactid, cmtactid, mobileno, email, relationship, username, lastname, firstname, totalcardno, expdate
                                , dtupdate, usrupdate)

                        })
                        .catch(error => {
                            this.setState({ errorMessage: error.toString() });
                            console.error('There was an error!', error);
                        });



                }
            }
            else {
                var data =
                {
                    "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
                    "MAPINAME": 'GetNicValue',
                    "MAPIPORT": process.env.REACT_APP_MPORT,
                    "body": {

                        // "Nic":"H040774301593E"
                        "NicId": "" + this.state.DDNIC + ""
                    }
                }
                fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
                    if (response.data["recordset"].length > 0) {
                        if (response.data["recordset"][0]["expdate"] != null) {
                            if (response.data["recordset"][0]["expdate"] == "") {
                                alert("Driver already exists")
                                return
                            }
                            else {
                                var r = window.confirm("Driver deactivated. Do you wish to reactivate driver?")
                                if (r) {
                                    var accid = response.data["recordset"][0]["swnactid"]
                                    var Exdate = ''
                                    this.updateUserandActivate(accid, Exdate)
                                    this.clearDDdetails()

                                }
                                else {

                                }
                            }

                        }
                    }
                    else {
                        var dateme = new Date()
                        const requestOptions = {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Cmt-Api-Key': '' + process.env.REACT_APP_HEADER_KEY + ''
                            },
                            body: JSON.stringify({
                                "users": [
                                    {
                                        "account_id": this.state.DDNIC.toUpperCase(),
                                        "email": this.state.input.DDEMAILADDRESS,
                                        "username": this.state.DDUSERNAME.toUpperCase(),
                                        "first_name": this.state.DDFIRSTNAME.toUpperCase(),
                                        "last_name": this.state.DDLASTNAME.toUpperCase(),
                                        "expiration_date": null,
                                        "mobile": this.state.DDMOBILENO.toUpperCase(),
                                        "mobile_sms": this.state.DDMOBILENO.toUpperCase()

                                    }
                                ]
                            })
                        };

                        // console.log("save CMD body",requestOptions.body)
                        fetch('' + process.env.REACT_APP_CLIENTMOBILE_URL + '', requestOptions)
                            .then(async response => {
                                const data = await response.json();
                                if (data.error_description != undefined) {
                                    alert(data.error_description)
                                    return
                                }

                                // check for error response
                                if (!response.ok) {
                                    // get error message from body or default to response status
                                    const error = (data && data.message) || response.status;
                                    return Promise.reject(error);
                                }
                                // console.log(data)
                                var swnactid = this.state.DDNIC.toUpperCase()
                                var cmtactid = data['users'][0]['short_user_id']
                                var mobileno = this.state.DDMOBILENO.toUpperCase()
                                var email = this.state.input.DDEMAILADDRESS
                                var relationship = this.state.DDFRELATIONSHIP.toUpperCase()
                                var username = this.state.DDUSERNAME.toUpperCase()
                                var lastname = this.state.DDLASTNAME.toUpperCase()
                                var firstname = this.state.DDFIRSTNAME.toUpperCase()
                                var totalcardno = this.state.DDTOTALCARDNO.toUpperCase()
                                var expdate = ""
                                var dtcreate = this.state.DDSELECTEDATE
                                var dtupdate = ""
                                var usrcreate = sessionStorage.getItem("username")
                                var usrupdate = ""
                                this.savewithIdResponse(swnactid, cmtactid, mobileno, email, relationship, username, lastname, firstname, totalcardno, expdate
                                    , dtcreate, dtupdate, usrcreate, usrupdate)
                                this.clearDDdetails()
                            })
                            .catch(error => {
                                this.setState({ errorMessage: error.toString() });
                                console.error('There was an error!', error);
                            });
                    }
                }).catch(e => console.log(e));
            }
        }
    }
    UpdateUserafterSearch(swnactid, cmtactid, mobileno, email, relationship, username, lastname, firstname, totalcardno, expdate
        , dtupdate, usrupdate) {

        var dataNew = {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GetMobileNo',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": {
                "swnactid": swnactid,
                "mobileNo": mobileno
            }
        }
        //  console.log("MobileUpdare sql body", dataNew)
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', dataNew, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            console.log('Mobile', response.data.MobileNo)
            var requestOptions = ""

            if (response.data.MobileNo == "FALSE") {
                requestOptions = {
                    method: 'POST',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                        'X-Cmt-Api-Key': '' + process.env.REACT_APP_HEADER_KEY + ''
                    },
                    body: JSON.stringify(
                        {
                            "users": [{
                                "short_user_id": cmtactid,
                                "mobile": mobileno
                            }]
                        }
                    )
                };
                // console.log("ded",requestOptions)
                fetch('' + process.env.REACT_APP_CLIENTMOBILE_URL + '', requestOptions)
                    .then(async response => {
                        const data = await response.json();
                        console.log(data)
                        if (data.error_description != undefined) {
                            alert(data.error_description)
                            return
                        }
                        // check for error response
                        if (!response.ok) {
                            // get error message from body or default to response status
                            const error = (data && data.message) || response.status;
                            return Promise.reject(error);
                        }
                    }).catch(e => console.log(e));

            }

        }).catch(e => console.log(e));

        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'UpdateTLMUSERACT',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": {
                "swnactid": swnactid,
                "cmtactid": cmtactid,
                "mobileno": mobileno,
                "email": email,
                "relationship": relationship,
                "username": username,
                "lastname": lastname,
                "firstname": firstname,
                "totalcardno": totalcardno,
                "expdate": expdate,
                "dtupdate": dtupdate,
                "usrupdate": usrupdate
            }
        }
        // console.log("update Save body",data)
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            alert(response.data)
            this.ClearGrid()
        }).catch(e => console.log(e));
    }

    updateUserandActivate(accid, exdate) {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Cmt-Api-Key': '' + process.env.REACT_APP_HEADER_KEY + ''
            },
            body: JSON.stringify({
                "users": [
                    {
                        "account_id": accid,
                        "expiration_date": exdate,
                        "username": this.state.DDUSERNAME.toUpperCase()

                    }
                ]
            })
        };
        // console.log("activate user CMT body",requestOptions.body)
        fetch('' + process.env.REACT_APP_CLIENTMOBILE_URL + '', requestOptions)
            .then(async response => {
                const data = await response.json();
                console.log(data)
                if (data.error_description != undefined) {
                    alert(data.error_description)
                    return
                }
                // check for error response
                if (!response.ok) {
                    // get error message from body or default to response status
                    const error = (data && data.message) || response.status;
                    return Promise.reject(error);
                }

                var shortID = data['users'][0]['short_user_id']
                var userupda = sessionStorage.getItem("username")
                var userupdate = this.state.DDSELECTEDATE
                this.updateandActivateuser(shortID, accid, userupdate, userupda)
                this.clearDDdetails()

            })
            .catch(error => {
                this.setState({ errorMessage: error.toString() });
                console.error('There was an error!', error);
            });

    }
    updateandActivateuser(cmtactid, swnactid, dtupdate, usrupdate) {

        var data = {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'ActivateDriver',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": {
                "cmtactid": cmtactid,
                "swnactid": swnactid,
                "usrupdate": usrupdate,
                "dtupdate": dtupdate,

            }
        }
        console.log("Activate sql body", data)
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            alert(response.data)
            this.ClearGrid()
        }).catch(e => console.log(e));
    }

    savewithIdResponse(swnactid, cmtactid, mobileno, email, relationship, username, lastname, firstname, totalcardno, expdate
        , dtcreate, dtupdate, usrcreate, usrupdate) {
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'SAVETLMUSERACT',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": {
                "swnactid": swnactid,
                "cmtactid": cmtactid,
                "mobileno": mobileno,
                "email": email,
                "relationship": relationship,
                "username": username,
                "lastname": lastname,
                "firstname": firstname,
                "totalcardno": totalcardno,
                "expdate": expdate,
                "dtcreate": dtcreate,
                "dtupdate": dtupdate,
                "usrcreate": usrcreate,
                "usrupdate": usrupdate
            }
        }
        // console.log("save sql body",data)
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            alert(response.data)
            this.ClearGrid()
        }).catch(e => console.log(e));
    }

    handleCancelClick() {
        var r = window.confirm("Do you want to Clear Details ?")
        if (r == true) {
            // this.ClearGrid()
            this.clearDDdetails()
        }
    }

    handleAddnewClick() {
        this.clearDDdetails()
        this.setState({ displayaddtext: '', disableDescription: false })
        this.setState({ disabled: true, DisabledButton: false, updatebuttonText: "Save", DELETEBUTTONCHANGE: BLUE_COLOR });



    }
    handleUpClick(){
        this.setState({ showDialog: true})
    }

    handeltextChange(e, key) {
        this.setState({ key: e.target.value });
        this.state[key] = e.target.value;
        if (key == "DDLASTNAME" || key == "DDFIRSTNAME") {
            if (this.state.DDFIRSTNAME == "" || this.state.DDLASTNAME == "") {
                this.setState({ DDUSERNAME: "" })
            }
            else {
                this.genrateuniqueusername()
            }
        }
    }
    genrateuniqueusername() {
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GetUniqueName',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": {
                "firstName": this.state.DDFIRSTNAME.trim() || "",
                "lastName": this.state.DDLASTNAME.trim() || "",
            }
        }
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            this.setState({
                DDUSERNAME: response.data
            })
        }).catch(e => console.log(e));
    }
    fetchDetails(rowObj) {
        // console.log(rowObj)
        this.setState({
            txtDesciption: rowObj['DESC50'],
            txtGrpcontestcode:rowObj['GROUP_CONTEST_CODE'],
            txtOrdering:rowObj['ORDERING'],
            txt_GROUP_CHARVAL_3: rowObj['GROUP_CHARVAL_3'],
            txt_GROUP_CHARVAL_1: rowObj['GROUP_CHARVAL_1'],
            txt_GROUP_CHARVAL_2: rowObj['GROUP_CHARVAL_2'],
            DDFRELATIONSHIP: rowObj['relationship'],
            DDMOBILENO: rowObj['mobileno'],
            disableDescription: true,
            DDTOTALCARDNO: rowObj['totalcardno'],
            DRIVEREXPDATE: rowObj['expdate'],
            DDEMAILADDRESS: "PC"
        })
        this.state.input.DDEMAILADDRESS = rowObj['email']

        this.setState({ disabled: true,displayaddtext:'none', DisabledButton: false, updatebuttonText: "Update", DELETEBUTTONCHANGE: BLUE_COLOR });

        // POST request using fetch with error handling
    }


    renderpages() {
        this.state.records = this.state.alldata.length;
        this.state.pages = parseInt(this.state.records / this.state.pageSize)
        if (this.state.records % this.state.pageSize > 0)
            this.state.pages++;
        this.state.showPager = this.state.pages > 1
        this.pageChange(0)
    }
    Searchdatavalue() {
        this.setState({ alldata: [] })

        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GetSearch',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": {
                // "Nic":"H040774301593E"
                "NicId": "" + this.state.DDNIC + "" || "",
                "firstname": this.state.DDFIRSTNAME || "",
                "lastname": this.state.DDLASTNAME || "",
                "username": this.state.DDUSERNAME || "",
                "relationship": this.state.DDFRELATIONSHIP || "",
                "email": this.state.input.DDEMAILADDRESS || "",
                "mobileno": this.state.DDMOBILENO || "",
                "cmtactid": "",
                "totalcardno": this.state.DDTOTALCARDNO || ""
            }
        }
        //  console.log("Body", data)
        this.state.CMLISLODING = true
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            //  console.log(response)
            if (response.data.Driverdetails == undefined) {
                alert("No data found!")
                this.ClearGrid()
            }
            else {
                if (response.data.Driverdetails.length == 0) {
                    alert("No data found!")
                    this.ClearGrid()
                }
                else {
                    if (response.data.Driverdetails.length > 10) {
                        var result = window.confirm("Do you want to see all records ? (If NO please enter Search Criteria.)")
                        if (result) {
                            this.setState({
                                alldata: response.data.Driverdetails
                            })
                            // console.log("Data is checking", this.state.alldata)
                            this.setState({
                                CMLISLODING: false
                            })
                            this.renderpages()
                        }

                        else {
                            this.ClearGrid()
                        }
                    }
                    else {
                        this.setState({
                            CMLISLODING: false,
                            alldata: response.data.Driverdetails
                        })
                        this.setState({
                            CMLISLODING: false
                        })
                    }
                }
                // console.log("Data me ye aayega", this.state.alldata)
                this.renderpages()
            }
        }).catch(e => console.log(e));

    }
    ClearGrid() {
        this.setState({
            alldata: [],
            CMLISLODING: false
        })
        this.renderpages()
    }
    pageChange(number) {
        this.state.current = number;
        var data = this.state.alldata.slice(this.state.current * this.state.pageSize, (this.state.current + 1) * this.state.pageSize);
        this.setState({ tablebuffer: data })

        this.state.pagesObj = [];
        if (this.state.pages < 10) {
            for (var i = 0; i < this.state.pages; i++)
                this.state.pagesObj.push(i);
        }
        else {
            var min = this.state.current - 5;
            var max = this.state.current + 5;
            if (min < 0)
                min = 0;
            if (max > this.state.pages)
                max = this.state.pages;
            if (max - min > 10) {
                min = this.state.current - 5;
                max = this.state.current + 5;
            }
            if (min > 0)
                this.state.pagesObj.push(0);
            for (var i = min; i < max; i++)
                this.state.pagesObj.push(i);
            if (max < this.state.pages - 1)
                this.state.pagesObj.push(this.state.pages - 1);

        }
    }
    isEven(n) {
        return n % 2 == 0;
    }
    fnfillgrpvaluesdropdown() {
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'getGrpvals',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": ''
        }

        fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            var drpdata = response.data['Groupvalues'][0]
            this.setState({ GroupingCodeArry: drpdata })
            console.log("All Data", drpdata)
        }).catch(e => console.log(e));
    }
    fnloadalldata(grpvalue) {
        this.setState({
            CMLISLODING: true
        })
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'getGroupdetailpf/' + grpvalue + '',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": ''
        }

        fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            var drpdata = response.data['Groupvaluesdetail'][0]
            console.log("All Data ji", drpdata)
            this.setState({
                alldata: drpdata
            })
            // console.log("Data is checking", this.state.alldata)
            this.setState({
                CMLISLODING: false
            })
            this.renderpages()
            this.setState({
                CMLISLODING: false
            })
            this.cleartextdetails()
        }).catch(e => console.log(e));
    }
    Nicchecking() {
        if (this.state.DDNIC.trim() == "") {
            this.Searchdatavalue()
        }
        else {
            var data =
            {
                "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
                "MAPINAME": 'GetNicValue',
                "MAPIPORT": process.env.REACT_APP_MPORT,
                "body": {
                    "Nic": "" + this.state.DDNIC + ""
                }
            }
            fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {

                if (response.data["NicValue"] == 0) {
                    // alert("Invaild NIC")
                    this.Searchdatavalue()
                }
                else {
                    this.Searchdatavalue()
                }
            }).catch(e => console.log(e));
        }
    }

    clearDDdetails() {
        this.setState({
            txt_GROUP_CHARVAL_1: "",
            tablebuffer: [],
            txt_GROUP_CHARVAL_2: "",
            txt_GROUP_CHARVAL_3: "",
            txtDesciption: '',
            txtGrpcontestcode: "",
            txtOrdering: "",
            txtnumVal: "",
            txtlblReceive: "",
            SelectedGroupingCode: "", disableDescription: true,
            DDFRELATIONSHIP: "",
            DDMOBILENO: "",
            displayaddtext: 'none',
            DDTOTALCARDNO: "", pages: 0, pagesObj: [],
        })
        this.setState({ disabled: false, DisabledButton: true, updatebuttonText: "Update", DELETEBUTTONCHANGE: LIGHTGRAY_COLOR });

    }
    cleartextdetails() {
        this.setState({
            txt_GROUP_CHARVAL_1: "",
            txt_GROUP_CHARVAL_2: "",
            txt_GROUP_CHARVAL_3: "",
            txtDesciption: '',
            txtGrpcontestcode: "",
            txtOrdering: "",
            txtnumVal: "",
            txtlblReceive: ""
        })
        // this.setState({ disabled: false, DisabledButton: true, updatebuttonText: "Update", DELETEBUTTONCHANGE: LIGHTGRAY_COLOR });

    }
    render() {

        return (
            <Fragment>
                <Navigationmenu selectedMenu={'MTNSVLS  '} />
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    style={{ marginTop: 35 }}
                >
                    <Paper elevation={2} style={{ minHeight: 100, width: '98%', borderRadius: 6 }}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <div style={{ minHeight: 100, width: '98%', borderRadius: 6 }}>

                                <Grid container spacing={2}>
                                    <Grid item xs={11}>
                                        <div style={{
                                            display: 'flex',
                                            marginBottom: 20,
                                            marginTop: 60
                                        }}>
                                            <Typography style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 25, paddingLeft: 10 }}>Maintenance of System value</Typography>
                                        </div>
                                    </Grid>
                                </Grid>

                                {/*FILTER DROPDOWNS*/}
                                <Grid container spacing={2}>
                                    <Grid item xs={1}>
                                        Grouping Value
                                    </Grid>
                                    <Grid item xs={3} ><Select style={{ height: '42px' }}
                                        fullWidth
                                        variant={"outlined"}
                                        value={this.state.SelectedGroupingCode}
                                        onChange={(e) =>
                                            this.setState(
                                                { SelectedGroupingCode: e.target.value },
                                                this.fnloadalldata(e.target.value)
                                            )
                                        }
                                    >
                                        <MenuItem value=''>
                                        </MenuItem>
                                        {this.state.GroupingCodeArry.map((team) => (
                                            <MenuItem value={team.GROUP_VALUES}>
                                                {team.GROUP_VALUES}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    </Grid>
                                    <Grid item xs={1} style={{ display: this.state.displayaddtext }}>
                                        Group Contest Code
                                    </Grid>

                                    <Grid item xs={3} style={{ display: this.state.displayaddtext }}>

                                        <TextField fullWidth
                                            value={this.state.txtGrpcontestcode}
                                            size="small"
                                            onChange={(e) => this.handeltextChange(e, "txtGrpcontestcode")} variant="outlined"
                                            inputProps={{ style: { textTransform: 'uppercase' } }}
                                        />
                                    </Grid>
                                    <Grid item xs={1} style={{ display: this.state.displayaddtext }}>
                                        Ordering
                                    </Grid>
                                    <Grid item xs={3} style={{ display: this.state.displayaddtext }}>
                                        <TextField fullWidth
                                            value={this.state.txtOrdering}
                                            size="small"
                                            onChange={(e) => this.handeltextChange(e, "txtOrdering")} variant="outlined"
                                            inputProps={{ style: { textTransform: 'uppercase' } }}
                                        />
                                    </Grid>
                                    <Grid item xs={1}>
                                        Description
                                    </Grid>

                                    <Grid item xs={3} >

                                        <TextField fullWidth disabled={this.state.disableDescription}
                                            value={this.state.txtDesciption}
                                            size="small"
                                            onChange={(e) => this.handeltextChange(e, "txtDesciption")} variant="outlined"
                                            inputProps={{ style: { textTransform: 'uppercase' } }}
                                        />
                                    </Grid>
                                    <Grid item xs={1} style={{ display: this.state.displayaddtext }}>
                                        Num Val
                                    </Grid>

                                    <Grid item xs={3} style={{ display: this.state.displayaddtext }}>

                                        <TextField fullWidth
                                            value={this.state.txtnumVal}
                                            size="small"
                                            onChange={(e) => this.handeltextChange(e, "txtnumVal")} variant="outlined"
                                            inputProps={{ style: { textTransform: 'uppercase' } }}
                                        />
                                    </Grid>
                                    <Grid item xs={1} style={{ display: this.state.displayaddtext }}>
                                        Label Receive
                                    </Grid>

                                    <Grid item xs={3} style={{ display: this.state.displayaddtext }} >

                                        <TextField fullWidth
                                            value={this.state.txtlblReceive}
                                            size="small"
                                            onChange={(e) => this.handeltextChange(e, "txtlblReceive")} variant="outlined"
                                            inputProps={{ style: { textTransform: 'uppercase' } }}
                                        />
                                    </Grid>

                                    <Grid item xs={1}>
                                        Group Val 1
                                    </Grid>
                                    <Grid item xs={3} >
                                        <TextField fullWidth
                                            value={this.state.txt_GROUP_CHARVAL_1}
                                            size="small"
                                            onChange={(e) => this.handeltextChange(e, "txt_GROUP_CHARVAL_1")} variant="outlined"
                                            inputProps={{ style: { textTransform: 'uppercase' } }}
                                        />
                                    </Grid>
                                    <Grid item xs={1}>
                                        Group Val 2
                                    </Grid>
                                    <Grid item xs={3} >

                                        <TextField fullWidth
                                            value={this.state.txt_GROUP_CHARVAL_2}
                                            size="small"
                                            onChange={(e) => this.handeltextChange(e, "txt_GROUP_CHARVAL_2")} variant="outlined"
                                            inputProps={{ style: { textTransform: 'uppercase' } }}
                                        />
                                    </Grid>

                                    <Grid item xs={1}>
                                        Group Val 3
                                    </Grid>
                                    <Grid item xs={3} >

                                        <TextField fullWidth
                                            value={this.state.txt_GROUP_CHARVAL_3}
                                            size="small"
                                            onChange={(e) => this.handeltextChange(e, "txt_GROUP_CHARVAL_3")} variant="outlined"
                                            inputProps={{ style: { textTransform: 'uppercase' } }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>


                                    <Grid item xs={6}>
                                        <Button disabled={(this.state.DisabledButton)} variant={'text'} onClick={(e) => this.handleUpdateClick(this.state.updatebuttonText)} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: this.state.DELETEBUTTONCHANGE, width: '121px', height: '40px' }}>
                                            {this.state.updatebuttonText}
                                        </Button>
                                        <Button variant={'text'} onClick={(e) => this.handleCancelClick(e)} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '121px', height: '40px', marginLeft: '10px' }}>
                                            Clear
                                        </Button>
                                        <Button variant={'text'} onClick={(e) => this.handleAddnewClick(e)} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '121px', height: '40px', marginLeft: '10px' }}>
                                            Add New
                                        </Button>
                                        <Button variant={'text'} onClick={(e) => this.handleUpClick(e)} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: 'orange', width: '121px', height: '40px', marginLeft: '10px' }}>
                                            View Updates
                                        </Button>
                                        {/* <Button variant={'text'} onClick={(e) => this.handlesaveClick(e)} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '121px', height: '40px' }}>
                                            Save
                                        </Button>

                                        <Button variant={'text'} onClick={(e) => this.handleCancelClick(e)} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '121px', height: '40px' }}>
                                            Cancel
                                        </Button> */}
                                    </Grid>
                                </Grid>



                                <Divider style={{ marginTop: 15 }} />
                                <Grid container spacing={2} style={{ marginTop: 10 }}>
                                    <TableContainer>
                                        <Table aria-label="simple table">
                                            <TableHead style={{ backgroundColor: 'rgba(241,241,241,1.0)' }}>
                                                <TableRow>
                                                    <TableCell style={{ borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">ORDERING</TableCell>
                                                    <TableCell style={{ borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">DESCRIPTION
                                                    </TableCell>
                                                    <TableCell  style={{ borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">GROUP_CHARVAL_1</TableCell>
                                                    <TableCell style={{ borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">GROUP_CHARVAL_2</TableCell>
                                                    <TableCell  style={{ borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">GROUP_CHARVAL_3</TableCell>
                                                    <TableCell style={{ borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">USER_INITIAL</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {!this.state.CMLISLODING ?
                                                    this.state.tablebuffer.map((obj, index) => {

                                                        var rowbackgroundColor = 'white';
                                                        if (this.isEven(index)) { rowbackgroundColor = ALTERNATEROW_BACKGROUND_COLOR; }

                                                        if (this.state.ishovered && this.state.hoverindex == index) { rowbackgroundColor = LIGHTGRAY_COLOR }
                                                        return (

                                                            <TableRow style={{ cursor: 'pointer' }} onClick={(e) => this.fetchDetails(obj)} key={index}>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.ORDERING}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.DESC50}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.GROUP_CHARVAL_1}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.GROUP_CHARVAL_2}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.GROUP_CHARVAL_3}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.USER_INITIAL}</TableCell>
                                                            </TableRow>
                                                        )
                                                    })
                                                    : <td colspan="9" align="center"> Loading.... <CircularProgress classes="CircularProgress" /></td>}
                                            </TableBody>
                                        </Table>
                                        <div style={this.state.showPager ? { height: 60, marginLeft: "600px", color: MODIFIEDBLACK, fontSize: "15px", textTransform: 'uppercase', fontFamily: 'Globerbold', wordBreak: "break-word" } : { display: "none" }} >
                                            {
                                                this.state.pagesObj.map((obj, index) => {
                                                    return (
                                                        <span style={{ padding: "0 3px", cursor: "pointer" }}>
                                                            <a style={this.state.current == obj ? { fontWeight: 'bold', color: BLUE_COLOR, fontSize: "30px" } : {}} onClick={() => this.pageChange(obj)} >{obj + 1}</a>
                                                        </span>
                                                    )
                                                })
                                            }
                                        </div>
                                    </TableContainer>
                                    <Divider></Divider>

                                </Grid>
                                <Divider style={{ marginTop: 15 }} />

                                <Grid container spacing={2} style={{ marginTop: 10 }}>
                                    <Grid item xs></Grid>
                                    <Grid item xs></Grid>

                                </Grid>
                                <Grid container spacing={2} style={{ marginTop: 20 }}></Grid>
                            </div>
                            <Dialog fullScreen style={{borderRadius:0}} onClose={()=>this.setState({showDialog:false})} aria-labelledby="customized-dialog-title" open={this.state.showDialog}>

              <Toolbar style={{ backgroundColor: '#00b7cd'}} >
                
                <Typography style={{ borderWidth: 0, color:'white', textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 25, paddingLeft: 10 }}>Maintenance of System value</Typography>
              <IconButton style={{marginLeft:'65%'}} edge="end" color="inherit" aria-label="close">
                  <CloseIcon onClick={()=>this.setState({showDialog:false})} />
                </IconButton></Toolbar>
          <Box
            display="flex"
            style={{marginTop: 20}}
            alignItems="center"
            justifyContent="center"
          >
           <UpdateRecords></UpdateRecords>
            </Box>
        </Dialog>
                        </Box>
                    </Paper>
                </Box>
            </Fragment>
        )
    }
}